/* Teaser "next chapter": i video hanno preload="none" e nessun autoplay — il download parte
   solo su mobile e solo quando il teaser si avvicina al viewport (rootMargin largo: quando
   l'utente ci arriva il loop è già partito; il poster copre l'attesa). Su desktop il blocco
   è nascosto: zero byte. Con prefers-reduced-motion resta il poster statico. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function boot() {
    var videos = document.querySelectorAll('.chapter-teaser-mobile video');
    if (!videos.length) return;
    var bp = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--off-breakpoint-desktop')) || 1200;
    if (window.innerWidth >= bp) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var playing = entry.target.play();
        if (playing && playing.catch) playing.catch(function () {});
        io.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    videos.forEach(function (video) { io.observe(video); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
